var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.59613V4.60917V5.03217V6.0239C0 6.39632 0.392549 6.63803 0.725094 6.47037L1.61065 6.0239L1.98836 5.83347L2 5.82761L3.4037 5.11991L3.47443 5.08425L4.13583 4.75079L4.73945 4.44647C5.10599 4.26167 5.10599 3.73833 4.73945 3.55353L4.13583 3.24921L3.47443 2.91576L3.4037 2.8801L2 2.1724L1.98836 2.16653L1.61065 1.9761L0.725095 1.52963C0.392549 1.36197 0 1.60368 0 1.9761V2.96784V2.96784V3.39084V3.40387V4.59613ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55229 8.44772 5 9 5H14V12H4V9C4 8.44772 3.55228 8 3 8C2.44772 8 2 8.44772 2 9V12C2 13.1046 2.89543 14 4 14H14C15.1046 14 16 13.1046 16 12V5C16 3.89543 15.1046 3 14 3H9ZM5 7C5 6.44772 5.44772 6 6 6H12C12.5523 6 13 6.44772 13 7C13 7.55229 12.5523 8 12 8H6C5.44772 8 5 7.55229 5 7ZM6 9C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11H10C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9H6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.1f065622362897c15ec62101243adb1d.svg";
export { ForwardRef as ReactComponent };